<template>
  <div class="fliggy-material" v-if="applicant.ota_material_set && applicant.ota_material_set.ota_zip_url">
    <div class="material-title">飞猪用户提交资料</div>
    <div class="material-body">
      <div class="material-zip">
        <div class="zip-name">{{applicant.ota_material_set.zip_file_name}}</div>
        <button class="s-btn btn-blue is-plain btn-size-28" @click="downloadZip">下载</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    applicant: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    downloadZip() {
      window.open(this.applicant.ota_material_set.ota_zip_url);
    },
  },
};
</script>

<style lang="less" scoped>
.fliggy-material{
  background: #fff;
  .material-title{
    background: #F2F8FF;
    height: 50px;
    width: 100%;
    padding: 0 30px;
    display: flex;
    align-items: center;
    color: #5E9BE1;
    font-size: 18px;
    font-weight: 600;
  }
  .material-body{
    padding: 30px;
    .material-zip{
      display: flex;
      align-items: center;
      .zip-name{
        color: #333;
        font-size: 18px;
        margin-right: 20px;
      }
      .s-btn{
        flex-shrink: 0;
      }
    }
    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/ota/fliggy-material.vue